import React, {Component} from 'react';
import './ReplyBox.css'
import Atts from './Atts'
import dataAtts from '../../data/tqq_attachment'
import dataWeibo from '../../data/tqq_weibo'


export default class extends Component {
    render() {
        if('REPLY_DELETED' === this.props.index)
            return this.render_deleted();

        const data = dataWeibo[this.props.index],
            atts = dataAtts[data.id] || [];

        return (
            <div className="reply-box">
                <p className="reply-user">
                    @{data.user}
                </p>
                <p className="reply-content" dangerouslySetInnerHTML={{__html:data.content}} />
                <Atts data={atts} />
                <p className="reply-meta">
                    原文评论和转发数 {data.popularity}
                </p>
            </div>
        )
    }

    render_deleted() {
        return (
            <div className="reply-box">
                <p className="reply-user" />
                <p className="reply-content">
                    原文已被删除 :(
                </p>
                <p className="reply-meta" />
            </div>
        );
    }
}



// WEBPACK FOOTER //
// ./src/main-content/weibo-module/ReplyBox.js